import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import HomeScreen from '../../screens/App/Home';
import DailyDevotionScreen from '../../screens/App/DailyDevotion';
import AuthorBio from '../../screens/App/AuthorBio';
import colors from '../../util/colors';

const Stack = createNativeStackNavigator();

const HomeStack = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false, contentStyle: { backgroundColor: colors.background }}}>
      <Stack.Screen name="HomeScreen" component={HomeScreen} />
      <Stack.Screen name="DailyDevotion" component={DailyDevotionScreen} />
      <Stack.Screen name="AuthorBio" component={AuthorBio} />
    </Stack.Navigator>
  );
};

export default HomeStack;